import { useMutation } from 'react-query';

import { NotificationPosition } from 'core/enums';
import { useHandleErrors } from 'core/hooks';
import { externalPricesService } from 'parts/services';
import { IExternalPricesPayload, IExternalPricesResponse } from 'parts/types';

export const useGetExternalPrices = () => {
  const { errors } = useHandleErrors({
    position: NotificationPosition.DRAWER,
  });

  const { mutateAsync, data, isLoading, isError, reset } = useMutation<
    { success: boolean; record: IExternalPricesResponse | null },
    unknown,
    IExternalPricesPayload
  >(externalPricesService.getExternalPrices, errors);

  return {
    getExternalPrices: mutateAsync,
    pricingData: data?.record ?? null,
    isLoading,
    isError,
    reset,
  };
};
